var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgResetPasswordIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 162,
    viewBox: "0 0 162 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.8666 77.6272V71.9268V64.6717C94.8666 62.6714 93.1919 61.0442 91.1332 61.0442C90.4804 61.0442 89.8767 61.2225 89.3423 61.5085C88.8623 60.043 87.465 58.9713 85.7999 58.9713C85.1471 58.9713 84.5434 59.1496 84.009 59.4356C83.529 57.9701 82.1316 56.8984 80.4666 56.8984C78.8015 56.8984 77.4042 57.9701 76.9242 59.4356C76.3898 59.1496 75.786 58.9713 75.1332 58.9713C73.0746 58.9713 71.3999 60.5985 71.3999 62.5988V64.2582C68.969 64.7401 67.1332 66.8327 67.1332 69.3357V77.6272C67.1332 81.2101 69.2036 84.4179 72.4666 85.985V91.1009H71.3999C70.81 91.1009 70.3332 91.5652 70.3332 92.1373V111.83C70.3332 112.402 70.81 112.866 71.3999 112.866H90.5999C91.1898 112.866 91.6666 112.402 91.6666 111.83V92.1373C91.6666 91.5652 91.1898 91.1009 90.5999 91.1009H89.5332V85.986C92.7962 84.4179 94.8666 81.2101 94.8666 77.6272ZM91.1332 63.1171C92.0154 63.1171 92.7332 63.8146 92.7332 64.6717V71.9268C92.7332 72.7839 92.0154 73.4814 91.1332 73.4814C90.2511 73.4814 89.5332 72.7839 89.5332 71.9268V64.6717C89.5332 63.8146 90.2511 63.1171 91.1332 63.1171ZM87.3999 62.5976C87.3999 61.7405 86.682 61.043 85.7999 61.043C84.9178 61.043 84.1999 61.7405 84.1999 62.5976V71.9256C84.1999 72.7827 84.9178 73.4802 85.7999 73.4802C86.682 73.4802 87.3999 72.7827 87.3999 71.9256V64.6705V62.5976ZM78.8666 60.5273C78.8666 59.6702 79.5844 58.9727 80.4666 58.9727C81.3487 58.9727 82.0666 59.6702 82.0666 60.5273V62.6002V71.9281C82.0666 72.7853 81.3487 73.4828 80.4666 73.4828C79.5844 73.4828 78.8666 72.7853 78.8666 71.9281V71.0461C80.1231 70.4616 80.9999 69.2241 80.9999 67.7824C80.9999 66.3407 80.1231 65.1032 78.8666 64.5186V62.6002V60.5273ZM75.1332 73.483C76.0154 73.483 76.7332 72.7855 76.7332 71.9284V71.4102H74.5999V73.3898C74.7695 73.4488 74.9487 73.483 75.1332 73.483ZM75.1333 61.043C76.0154 61.043 76.7333 61.7405 76.7333 62.5976V64.1523H73.5333V62.5976C73.5333 61.7405 74.2511 61.043 75.1333 61.043ZM89.5332 95.2448V93.1719H72.4666V95.2448H89.5332ZM72.4666 110.793V97.3195H89.5332V110.793H72.4666ZM74.5999 85.3155V91.1009H87.3999V85.3155C87.3999 84.8936 87.6634 84.5133 88.0666 84.3547C90.9007 83.2405 92.7332 80.5997 92.7332 77.6272V75.1905C92.2468 75.4165 91.7082 75.5543 91.1332 75.5543C90.0879 75.5543 89.145 75.1325 88.4666 74.4578C87.7882 75.1325 86.8452 75.5543 85.7999 75.5543C84.7546 75.5543 83.8116 75.1325 83.1332 74.4578C82.4548 75.1325 81.5119 75.5543 80.4666 75.5543C79.4212 75.5543 78.4783 75.1325 77.7999 74.4578C77.1215 75.1325 76.1786 75.5543 75.1332 75.5543C74.953 75.5543 74.7759 75.5367 74.5999 75.5129V75.6279C78.2138 76.1326 80.9999 79.1601 80.9999 82.8094H78.8666C78.8666 79.9519 76.474 77.6272 73.5332 77.6272C72.9434 77.6272 72.4666 77.1629 72.4666 76.5907V70.3721C72.4666 69.8 72.9434 69.3357 73.5332 69.3357H77.2666C78.1487 69.3357 78.8666 68.6382 78.8666 67.781C78.8666 66.9239 78.1487 66.2264 77.2666 66.2264H72.4666C70.7023 66.2264 69.2666 67.6214 69.2666 69.3357V77.6272C69.2666 80.5986 71.0991 83.2405 73.9332 84.3547C74.3364 84.5133 74.5999 84.8936 74.5999 85.3155Z",
    fill: "#4A4A4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5999 80.738H60.7332C60.7332 72.9377 57.8607 65.5998 52.6436 60.0756L51.9183 59.3086L50.3471 60.7109L51.0714 61.4779C55.8564 66.544 58.5999 73.5638 58.5999 80.738Z",
    fill: "#D2D2D2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.927 61.4779L111.653 60.7109L110.081 59.3086L109.355 60.0756C104.139 65.5998 101.267 72.9377 101.267 80.738H103.4C103.4 73.5638 106.143 66.544 110.927 61.4779Z",
    fill: "#4A4A4A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9998 68.4758C64.9998 62.4893 67.2334 56.6334 71.1278 52.411L69.5385 51.0273C65.2366 55.6934 62.8665 61.8902 62.8665 68.4758V69.3381H64.9998V68.4758Z",
    fill: "#D2D2D2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9999 69.3381H99.1332V68.4758C99.1332 61.8902 96.7631 55.6934 92.4612 51.0273L90.8719 52.411C94.7663 56.6334 96.9999 62.4893 96.9999 68.4758V69.3381Z",
    fill: "#4A4A4A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5999 66.2281H60.7332V65.8167C60.7332 59.767 58.8207 53.966 55.2004 49.043L53.466 50.2473C56.8239 54.817 58.5999 60.2013 58.5999 65.8167V66.2281Z",
    fill: "#4A4A4A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M103.4 65.8156C103.4 60.2002 105.176 54.817 108.534 50.2473L106.798 49.043C103.179 53.965 101.267 59.7649 101.267 65.8156V66.2271H103.4V65.8156Z",
    fill: "#D2D2D2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1332 71.4102H53.2666V73.483H51.1332V71.4102Z",
    fill: "#4A4A4A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2665 73.4844H55.3999V75.5572H53.2665V73.4844Z",
    fill: "#4A4A4A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1332 75.5547H53.2666V77.6276H51.1332V75.5547Z",
    fill: "#4A4A4A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9999 73.4844H51.1332V75.5572H48.9999V73.4844Z",
    fill: "#4A4A4A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M108.733 71.4102H110.867V73.483H108.733V71.4102Z",
    fill: "#4A4A4A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M110.867 73.4844H113V75.5572H110.867V73.4844Z",
    fill: "#4A4A4A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M108.733 75.5547H110.867V77.6276H108.733V75.5547Z",
    fill: "#4A4A4A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M106.6 73.4844H108.733V75.5572H106.6V73.4844Z",
    fill: "#4A4A4A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9999 81.7734H99.1332V83.8463H96.9999V81.7734Z",
    fill: "#4A4A4A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1332 83.8477H101.267V85.9205H99.1332V83.8477Z",
    fill: "#4A4A4A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9999 85.9219H99.1332V87.9947H96.9999V85.9219Z",
    fill: "#4A4A4A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8665 83.8477H96.9998V85.9205H94.8665V83.8477Z",
    fill: "#4A4A4A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8665 81.7734H64.9998V83.8463H62.8665V81.7734Z",
    fill: "#4A4A4A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9999 83.8477H67.1332V85.9205H64.9999V83.8477Z",
    fill: "#4A4A4A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8665 85.9219H64.9998V87.9947H62.8665V85.9219Z",
    fill: "#4A4A4A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7332 83.8477H62.8665V85.9205H60.7332V83.8477Z",
    fill: "#4A4A4A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1999 51.7188H86.3332V53.7916H84.1999V51.7188Z",
    fill: "#4A4A4A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4666 53.7891H74.5999V55.8619H72.4666V53.7891Z",
    fill: "#4A4A4A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4164 89.8129C55.7828 92.3719 54.3332 95.7735 54.3332 99.3927H56.4665C56.4665 96.3269 57.6943 93.4457 59.9247 91.2795L60.4207 90.7986L58.9124 89.332L58.4164 89.8129Z",
    fill: "#4A4A4A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M103.087 89.332L101.579 90.7986L102.075 91.2795C104.306 93.4467 105.533 96.328 105.533 99.3938H107.667C107.667 95.7745 106.217 92.3729 103.583 89.814L103.087 89.332Z",
    fill: "#D2D2D2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80.9999,
    cy: 80.9961,
    r: 60,
    transform: "rotate(-180 80.9999 80.9961)",
    stroke: "#4A4A4A",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 81,
    r: 79,
    stroke: "#F1F1F1",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgResetPasswordIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/resetPasswordIcon.df846f02cea7df4038152720a2635c72.svg";